import { FiDownload } from "react-icons/fi";
import { FaLocationCrosshairs } from "react-icons/fa6";
import FilePreviewDialog, {
  type PreviewNavigationDirection,
} from "@/components/preview/filePreviewDialog";
import { FileSystemItem } from "./types";

type PreviewMeta = {
  assetType: string;
  canPreview: boolean;
};

type BrowsePreviewDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  previewItem: FileSystemItem | null;
  previewMeta: PreviewMeta;
  previewUrl: string | null;
  previewDownloadUrl: string | null;
  hasDeploymentFeature: boolean;
  isOpeningDeployment: boolean;
  onSeeDeployment: (item: FileSystemItem) => void;
  onPrevious: () => void;
  onNext: () => void;
  hasPrevious: boolean;
  hasNext: boolean;
  navigatingDirection: PreviewNavigationDirection;
};

const BrowsePreviewDialog = ({
  isOpen,
  onClose,
  previewItem,
  previewMeta,
  previewUrl,
  previewDownloadUrl,
  hasDeploymentFeature,
  isOpeningDeployment,
  onSeeDeployment,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  navigatingDirection,
}: BrowsePreviewDialogProps) => (
  <FilePreviewDialog
    isOpen={isOpen}
    onClose={onClose}
    title={previewItem?.name || "Preview"}
    subtitle={previewItem?.path}
    previewMeta={previewMeta}
    previewUrl={previewUrl}
    onPrevious={onPrevious}
    onNext={onNext}
    hasPrevious={hasPrevious}
    hasNext={hasNext}
    navigatingDirection={navigatingDirection}
    actions={
      <>
        {previewDownloadUrl ? (
          <a
            href={previewDownloadUrl}
            className="ox-button flex min-h-10 items-center gap-2 rounded-md px-4 py-2"
          >
            <FiDownload />
            Download
          </a>
        ) : (
          <button
            className="ox-button flex min-h-10 cursor-not-allowed items-center gap-2 rounded-md px-4 py-2 opacity-60"
            disabled
          >
            <FiDownload />
            Download
          </button>
        )}
        {previewItem?.realAssetDeploymentPublicId && hasDeploymentFeature && (
          <button
            className={`ox-button flex min-h-10 items-center gap-2 rounded-md px-4 py-2 ${
              isOpeningDeployment ? "opacity-70" : ""
            }`}
            onClick={() => previewItem && onSeeDeployment(previewItem)}
            disabled={isOpeningDeployment}
          >
            <FaLocationCrosshairs />
            See Deployment
          </button>
        )}
      </>
    }
  />
);

export default BrowsePreviewDialog;
